import colors from '_containers/Theme/intheblack/colors';

export default {
  background: `transparent`,
  action: colors.all.interactive400,
  playButtonBackground: colors.all.interactive400,
};
